<template>
  <div class="page-api-youtube">
    <div class="columns">
      <div class="column content">
        <div class="container">
          <p class="title">
            Google Youtube API.<br />
            <div class="g-ytsubscribe" data-channel="nadeemadamlobo" data-layout="default" data-theme="dark" data-count="hidden"></div>
          </p>
          <p class="subtitle" style="margin-bottom:30px;">
            Request for Google Youtube.
          </p>
          <div class="control notification is-danger" v-if="error">
            <button class="delete" @click="error = undefined"></button>
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-unused-vars: off */
import Auth from '@/apis/Auth'
// import auth from '@/apis/Auth'
// import Youtube from 'youtube-api'
// const Youtube = require('youtube-api')
// const fs = require('fs')
// const readJson = require('r-json')
// const Lien = require('lien')
// const Logger = require('bug-killer')
// const opn = require('opn')
// const prettyBytes = require('pretty-bytes')
export default {
  data () {
    return {
      error: undefined
    }
  },
  methods: {
    test () {
    }
  },
  beforeCreate () {
  },
  created () {
    console.log('created ApiYoutube.vue')
  },
  mounted () {
    console.log('mounted ApiYoutube.vue')
    // Youtube.authenticate({
    //   type: 'key',
    //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
    // })
    // var params = {
    //   term: 'search',
    //   part: 'snippet',
    //   channelId: 'UCLXo7UDZvByw2ixzpQCufnA',
    //   order: 'date',
    //   type: 'video',
    //   videoSyndicated: true,
    //   maxResults: 50,
    //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
    // }
    // apis.get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCLXo7UDZvByw2ixzpQCufnA&order=date&type=video&videoSyndicated=true&maxResults=50&key=AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM')
    var params = {
      term: 'playlistItems',
      part: 'snippet',
      playlistId: 'UUy4ssRxw_k0XdiH31OxVHmA',
      maxResults: 12,
      key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
    }
    Auth.youtube(params.term, params)
    .then((data) => {
      console.log('Youtube Response')
      console.log(data)
    })
    .catch((error) => {
      console.log('Youtube Error')
      console.log(error)
    })
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-api-youtube {
}
</style>



// WEBPACK FOOTER //
// ApiYoutube.vue?309448f3